import type { DateRangePickerValue } from '@shigo-ui/ui';

import type { ReportMetric } from '../reportExplorer/reportEnums';

export enum PerformanceAnalyzerTab {
  PublisherDemand = 'PUBLISHER_DEMAND',
  Stitcher = 'STITCHER',
}

export enum PerformanceDrilldownType {
  Publishers = 'PUBLISHERS',
  DemandPartners = 'DEMAND_PARTNERS',
}

export interface PerformanceEntityOption {
  id: string;
  label: string;
}

export interface PerformanceAnalyzerRange {
  primary: DateRangePickerValue;
  comparison: DateRangePickerValue | null;
}

export interface PerformanceEntityChartConfiguration {
  identityField: string;
  metrics: ReportMetric[];
}

export function previousPerformanceRange(value: DateRangePickerValue): DateRangePickerValue {
  const from = new Date(`${value.dateFrom}T00:00:00Z`);
  const to = new Date(`${value.dateTo}T00:00:00Z`);
  const days = Math.max(1, Math.round((to.getTime() - from.getTime()) / 86_400_000) + 1);
  to.setUTCDate(from.getUTCDate() - 1);
  from.setUTCDate(from.getUTCDate() - days);
  return {
    dateFrom: from.toISOString().slice(0, 10),
    dateTo: to.toISOString().slice(0, 10),
    preset: '',
  };
}
